/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@ngx-translate/core/src/translate.pipe';
import * as i2 from '@ngx-translate/core/src/translate.service';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/common';
import * as i5 from '../../../../../src/app/directives/input-focused.directive';
import * as i6 from '../../modules/algolia/algolia-search/algolia-search.component.ngfactory';
import * as i7 from '../../../../../src/app/modules/algolia/algolia-search/algolia-search.component';
import * as i8 from '../../../../../src/app/modules/algolia/algolia.service';
import * as i9 from '../../../../../src/app/mixpanel/mixpanel.service';
import * as i10 from '../../../../../src/app/order/wizard/orderpart.component';
import * as i11 from '@angular/router';
import * as i12 from '@angular/platform-browser';
import * as i13 from '../../../../../src/app/modules/features/flag.service';
import * as i14 from '../../../../../src/app/order/order.service';
import * as i15 from '../../../../../src/app/order/currentOrder.service';
import * as i16 from '../../../../../src/app/order/orderValidation';
var styles_OrderPartComponent = [];
export var RenderType_OrderPartComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_OrderPartComponent, data: {} });
function View_OrderPartComponent_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'h3', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['1. ', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.PARTS.TITLE'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderPartComponent_2(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'h3', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['1. ', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.PARTS.TITLE_QUOTE'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderPartComponent_3(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'p', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                ', '.\n            '])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.PARTS.MESSAGE_2'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderPartComponent_4(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'p', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                ', '.\n            '])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.PARTS.MESSAGE_2_QUOTE'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderPartComponent_7(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 9, 'div', [['class',
                'col col-sm-2 col-xs-6 form-group']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'label', [['class', 'control-label']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵeld(0, null, null, 0, 'br', [], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                                                ']))], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 3, 0, i0.ɵnov(_v, 4).transform('ORDER.FORM.PARTS.LABEL.SOURCE_SYSTEM'));
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _v.parent.context.$implicit.brand;
        _ck(_v, 8, 0, currVal_1);
    });
}
function View_OrderPartComponent_9(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 12, 'div', [['class',
                'add']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 5, 'input', [['type', 'file']], [[8,
                'id', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'change'], [null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 3)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 3).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 3)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 3)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (_co.attachFile($event, _v.parent.parent.context.$implicit, _v.parent.parent.context.index) !== false);
                ad = (pd_4 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_5 = ((_v.parent.parent.context.$implicit.file = $event) !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i3.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i3.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i3.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i3.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i3.NgModel, [[8, null],
            [8, null], [8, null], [2, i3.NG_VALUE_ACCESSOR]], { model: [0,
                'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i3.NgControl, null, [i3.NgModel]), i0.ɵdid(16384, null, 0, i3.NgControlStatus, [i3.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                                                        '])), (_l()(),
            i0.ɵeld(0, null, null, 2, 'label', [['class', '']], [[8, 'htmlFor',
                    0]], null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                                    ']))], function (_ck, _v) {
        var currVal_8 = _v.parent.parent.context.$implicit.file;
        _ck(_v, 5, 0, currVal_8);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵinlineInterpolate(1, 'file', _v.parent.parent.context.index, '');
        var currVal_1 = i0.ɵnov(_v, 7).ngClassUntouched;
        var currVal_2 = i0.ɵnov(_v, 7).ngClassTouched;
        var currVal_3 = i0.ɵnov(_v, 7).ngClassPristine;
        var currVal_4 = i0.ɵnov(_v, 7).ngClassDirty;
        var currVal_5 = i0.ɵnov(_v, 7).ngClassValid;
        var currVal_6 = i0.ɵnov(_v, 7).ngClassInvalid;
        var currVal_7 = i0.ɵnov(_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_9 = i0.ɵinlineInterpolate(1, 'file', _v.parent.parent.context.index, '');
        _ck(_v, 9, 0, currVal_9);
        var currVal_10 = i0.ɵunv(_v, 10, 0, i0.ɵnov(_v, 11).transform('ORDER.FORM.PARTS.LABEL.FILE_ADD'));
        _ck(_v, 10, 0, currVal_10);
    });
}
function View_OrderPartComponent_10(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 0, 'div', [['class',
                'loading']], null, null, null, null, null))], null, null);
}
function View_OrderPartComponent_11(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 5, 'div', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'div', [['class', 'remove']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = ((_v.parent.parent.context.$implicit.fileName = null) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['\n                                                            ',
            ' : ', '\n                                                        '])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                                    ']))], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 3, 0, i0.ɵnov(_v, 4).transform('ORDER.FORM.PARTS.LABEL.FILE_REMOVE'));
        var currVal_1 = _v.parent.parent.context.$implicit.fileName;
        _ck(_v, 3, 0, currVal_0, currVal_1);
    });
}
function View_OrderPartComponent_8(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 10, 'div', [['class',
                'col-md-12 file-select']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_9)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_10)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_11)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (!_v.parent.context.$implicit.fileName && !_co.uploadingFile[_v.parent.context.index]);
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _co.uploadingFile[_v.parent.context.index];
        _ck(_v, 6, 0, currVal_1);
        var currVal_2 = _v.parent.context.$implicit.fileName;
        _ck(_v, 9, 0, currVal_2);
    }, null);
}
function View_OrderPartComponent_6(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 114, 'div', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                                        '])), (_l()(),
            i0.ɵeld(0, null, null, 51, 'div', [['class', 'col-sm-7']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                            '])), (_l()(), i0.ɵeld(0, null, null, 48, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵeld(0, null, null, 9, 'div', [['class', 'col col-sm-3 col-xs-6 form-group']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'label', [['class', 'control-label']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵeld(0, null, null, 0, 'br', [], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵeld(0, null, null, 9, 'div', [['class', 'col col-sm-2 col-xs-6 form-group']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'label', [['class', 'control-label']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵeld(0, null, null, 0, 'br', [], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵeld(0, null, null, 9, 'div', [['class', 'col col-sm-1 col-xs-6 form-group']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'label', [['class', 'control-label']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵeld(0, null, null, 0, 'br', [], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵeld(0, null, null, 9, 'div', [['class', 'col col-sm-4 col-xs-6 form-group']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'label', [['class', 'control-label']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵeld(0, null, null, 0, 'br', [], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_7)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 0, 'div', [['class', 'clearfix visible-xs']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 44, 'div', [['class', 'col-sm-4']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵeld(0, null, null, 41, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                '])), (_l()(), i0.ɵeld(0, null, null, 20, 'div', [['class', 'col col-md-4']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                    '])), (_l()(), i0.ɵeld(0, null, null, 2, 'label', [['class', 'control-label']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ' *'])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 9, 'input', [['autocomplete', 'off'],
            ['class', 'form-control'], ['focused', ''], ['min', '1'], ['required', ''], ['type',
                'number']], [[8, 'id', 0], [1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'keyup'], [null, 'blur'], [null, 'input'], [null, 'compositionstart'],
            [null, 'compositionend'], [null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 68)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 68).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 68)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 68)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (i0.ɵnov(_v, 69).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('input' === en)) {
                var pd_5 = (i0.ɵnov(_v, 69).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
                var pd_6 = (i0.ɵnov(_v, 69).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_7 = ((_v.context.$implicit.Qty = $event) !== false);
                ad = (pd_7 && ad);
            }
            if (('keyup' === en)) {
                var pd_8 = (_co.checkField($event) !== false);
                ad = (pd_8 && ad);
            }
            if (('blur' === en)) {
                var pd_9 = (_co.checkField($event) !== false);
                ad = (pd_9 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i3.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i3.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵdid(16384, null, 0, i3.ɵbc, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵdid(16384, null, 0, i3.RequiredValidator, [], { required: [0, 'required'] }, null), i0.ɵprd(1024, null, i3.NG_VALIDATORS, function (p0_0) {
            return [p0_0];
        }, [i3.RequiredValidator]), i0.ɵprd(1024, null, i3.NG_VALUE_ACCESSOR, function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [i3.DefaultValueAccessor, i3.ɵbc]), i0.ɵdid(671744, null, 0, i3.NgModel, [[8, null], [2, i3.NG_VALIDATORS], [8, null], [2, i3.NG_VALUE_ACCESSOR]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i3.NgControl, null, [i3.NgModel]), i0.ɵdid(16384, null, 0, i3.NgControlStatus, [i3.NgControl], null, null), i0.ɵdid(81920, null, 0, i5.InputFocusedDirective, [i0.Renderer, i0.ElementRef], null, null), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'span', [['class', 'help-block']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵeld(0, null, null, 13, 'div', [['class', 'col col-md-8']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 6, 'textarea', [['class', 'form-control'],
            ['type', 'text']], [[8, 'placeholder', 0], [2, 'ng-untouched', null], [2,
                'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 90)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 90).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 90)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 90)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_v.context.$implicit.Note = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i3.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i3.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i3.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i3.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i3.NgModel, [[8, null],
            [8, null], [8, null], [2, i3.NG_VALUE_ACCESSOR]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i3.NgControl, null, [i3.NgModel]), i0.ɵdid(16384, null, 0, i3.NgControlStatus, [i3.NgControl], null, null), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                                '])), (_l()(), i0.ɵted(null, ['\n                                                '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_8)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 6, 'div', [['class', 'col-sm-1']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵeld(0, null, null, 3, 'div', [['class', 'icon-remove btn-icon btn-height']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.removeItem(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa-pt pt-remove']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 0, 'div', [['class', 'clearfix']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 0, 'hr', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_8 = _co.isItemBrandActive;
        _ck(_v, 51, 0, currVal_8);
        var currVal_19 = '';
        _ck(_v, 70, 0, currVal_19);
        var currVal_20 = i0.ɵinlineInterpolate(1, 'qty', _v.context.index, '');
        var currVal_21 = _v.context.$implicit.Qty;
        _ck(_v, 73, 0, currVal_20, currVal_21);
        _ck(_v, 76, 0);
        var currVal_32 = i0.ɵinlineInterpolate(1, 'note', _v.context.index, '');
        var currVal_33 = _v.context.$implicit.Note;
        _ck(_v, 92, 0, currVal_32, currVal_33);
        var currVal_34 = _co.flag.isFileItemActive();
        _ck(_v, 99, 0, currVal_34);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 9, 0, i0.ɵnov(_v, 10).transform('ORDER.FORM.PARTS.LABEL.PART_NUMBER'));
        _ck(_v, 9, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.PartNumber;
        _ck(_v, 14, 0, currVal_1);
        var currVal_2 = i0.ɵunv(_v, 20, 0, i0.ɵnov(_v, 21).transform('ORDER.FORM.PARTS.LABEL.DRAWING_NUMBER'));
        _ck(_v, 20, 0, currVal_2);
        var currVal_3 = _v.context.$implicit.DrawingNum;
        _ck(_v, 25, 0, currVal_3);
        var currVal_4 = i0.ɵunv(_v, 31, 0, i0.ɵnov(_v, 32).transform('ORDER.FORM.PARTS.LABEL.UOM'));
        _ck(_v, 31, 0, currVal_4);
        var currVal_5 = _v.context.$implicit.Uom;
        _ck(_v, 36, 0, currVal_5);
        var currVal_6 = i0.ɵunv(_v, 42, 0, i0.ɵnov(_v, 43).transform('ORDER.FORM.PARTS.LABEL.DESCRIPTION'));
        _ck(_v, 42, 0, currVal_6);
        var currVal_7 = _v.context.$implicit.Description;
        _ck(_v, 47, 0, currVal_7);
        var currVal_9 = i0.ɵunv(_v, 64, 0, i0.ɵnov(_v, 65).transform('ORDER.FORM.PARTS.LABEL.QUANTITY'));
        _ck(_v, 64, 0, currVal_9);
        var currVal_10 = i0.ɵinlineInterpolate(1, 'Qty', _v.context.index, '');
        var currVal_11 = (i0.ɵnov(_v, 70).required ? '' : null);
        var currVal_12 = i0.ɵnov(_v, 75).ngClassUntouched;
        var currVal_13 = i0.ɵnov(_v, 75).ngClassTouched;
        var currVal_14 = i0.ɵnov(_v, 75).ngClassPristine;
        var currVal_15 = i0.ɵnov(_v, 75).ngClassDirty;
        var currVal_16 = i0.ɵnov(_v, 75).ngClassValid;
        var currVal_17 = i0.ɵnov(_v, 75).ngClassInvalid;
        var currVal_18 = i0.ɵnov(_v, 75).ngClassPending;
        _ck(_v, 67, 0, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18);
        var currVal_22 = i0.ɵunv(_v, 79, 0, i0.ɵnov(_v, 80).transform('ORDER.FORM.FIELD_REQUIRED'));
        _ck(_v, 79, 0, currVal_22);
        var currVal_23 = i0.ɵunv(_v, 86, 0, i0.ɵnov(_v, 87).transform('ORDER.FORM.PARTS.LABEL.NOTE'));
        _ck(_v, 86, 0, currVal_23);
        var currVal_24 = i0.ɵinlineInterpolate(1, '', i0.ɵunv(_v, 89, 0, i0.ɵnov(_v, 95).transform('ORDER.FORM.PARTS.PLACEHOLDER.NOTE')), '');
        var currVal_25 = i0.ɵnov(_v, 94).ngClassUntouched;
        var currVal_26 = i0.ɵnov(_v, 94).ngClassTouched;
        var currVal_27 = i0.ɵnov(_v, 94).ngClassPristine;
        var currVal_28 = i0.ɵnov(_v, 94).ngClassDirty;
        var currVal_29 = i0.ɵnov(_v, 94).ngClassValid;
        var currVal_30 = i0.ɵnov(_v, 94).ngClassInvalid;
        var currVal_31 = i0.ɵnov(_v, 94).ngClassPending;
        _ck(_v, 89, 0, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31);
    });
}
function View_OrderPartComponent_12(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'div', [['class',
                'bubble-step']], null, null, null, null, null)),
        (_l()(), i0.ɵeld(0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['+']))], null, null);
}
function View_OrderPartComponent_13(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'label', [['class',
                'control-label']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ' *'])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.PARTS.LABEL.PART_STEP'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderPartComponent_14(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'label', [['class',
                'control-label']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ' *'])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.PARTS.LABEL.PART_STEP_QUOTE'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderPartComponent_17(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'label', [['class',
                'col-sm-1']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.FORM.PARTS.LABEL.SOURCE_SYSTEM'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderPartComponent_16(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 22, 'div', [['class',
                'row list-group-item hidden-xs'], ['style', 'border:none;']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'label', [['class', 'col-sm-3']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'label', [['class', 'col-sm-2']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'label', [['class', 'col-sm-1']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 4, 'label', [], null, null, null, null, null)), i0.ɵdid(278528, null, 0, i4.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers, i0.ElementRef,
            i0.Renderer], { ngClass: [0, 'ngClass'] }, null), i0.ɵpod({ 'col-sm-4': 0,
            'col-sm-5': 1 }), (_l()(), i0.ɵted(null, ['\n                                                        ',
            ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_17)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_3 = _ck(_v, 16, 0, _co.isItemBrandActive, !_co.isItemBrandActive);
        _ck(_v, 15, 0, currVal_3);
        var currVal_5 = _co.isItemBrandActive;
        _ck(_v, 21, 0, currVal_5);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 3, 0, i0.ɵnov(_v, 4).transform('ORDER.FORM.PARTS.LABEL.PART_NUMBER'));
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = i0.ɵunv(_v, 7, 0, i0.ɵnov(_v, 8).transform('ORDER.FORM.PARTS.LABEL.DRAWING_NUMBER'));
        _ck(_v, 7, 0, currVal_1);
        var currVal_2 = i0.ɵunv(_v, 11, 0, i0.ɵnov(_v, 12).transform('ORDER.FORM.PARTS.LABEL.UOM'));
        _ck(_v, 11, 0, currVal_2);
        var currVal_4 = i0.ɵunv(_v, 17, 0, i0.ɵnov(_v, 18).transform('ORDER.FORM.PARTS.LABEL.DESCRIPTION'));
        _ck(_v, 17, 0, currVal_4);
    });
}
function View_OrderPartComponent_15(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_16)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                            ']))], function (_ck, _v) {
        var currVal_0 = (_v.context.nbrResults > 0);
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_OrderPartComponent_20(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'i', [['class',
                'fa fa-warning']], [[8, 'title', 0]], null, null, null, null)), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵinlineInterpolate(1, '', i0.ɵunv(_v, 0, 0, i0.ɵnov(_v, 1).transform('ORDER.FORM.PARTS.DUPLICATE_ITEM')), '');
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_OrderPartComponent_19(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class',
                'col-xs-1']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                                '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_20)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                            ']))], function (_ck, _v) {
        var currVal_0 = (_v.parent.context.$implicit.partNum_exists > 0);
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_OrderPartComponent_21(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 12, 'div', [['class',
                'col-sm-1']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 9, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                            '])), (_l()(),
            i0.ɵeld(0, null, null, 2, 'label', [['class', 'visible-xs-inline-block col-xs-4']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                                            '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'div', [['class', 'col-xs-8 col-sm-12']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, [' ', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                                    ']))], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 5, 0, i0.ɵnov(_v, 6).transform('ORDER.FORM.PARTS.LABEL.SOURCE_SYSTEM'));
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = i0.ɵunv(_v, 9, 0, i0.ɵnov(_v, 10).transform(_v.parent.context.$implicit.Brand));
        _ck(_v, 9, 0, currVal_1);
    });
}
function View_OrderPartComponent_18(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵeld(0, null, null, 69, 'div', [['class', 'row list-group-item algolia-result pointer']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.addPart(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(278528, null, 0, i4.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers, i0.ElementRef, i0.Renderer], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), i0.ɵpod({ active: 0 }), (_l()(),
            i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 16, 'div', [['class', 'col-sm-3']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 13, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                            '])), (_l()(),
            i0.ɵeld(0, null, null, 2, 'label', [['class', 'visible-xs-inline-block col-xs-4']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                                            '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_19)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                            '])),
        (_l()(), i0.ɵeld(0, null, null, 3, 'div', [], null, null, null, null, null)), i0.ɵdid(278528, null, 0, i4.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers, i0.ElementRef,
            i0.Renderer], { ngClass: [0, 'ngClass'] }, null), i0.ɵpod({ 'col-xs-7 col-sm-9': 0,
            'col-xs-8 col-sm-11': 1 }), (_l()(), i0.ɵted(null, ['', ''])), (_l()(),
            i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'col-sm-2']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                            '])), (_l()(),
            i0.ɵeld(0, null, null, 2, 'label', [['class', 'visible-xs-inline-block col-xs-4']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                                            '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'div', [['class', 'col-xs-8 col-sm-12']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, [' ', ' '])), (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'col-sm-1']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                            '])), (_l()(),
            i0.ɵeld(0, null, null, 2, 'label', [['class', 'visible-xs-inline-block col-xs-4']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                                            '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'div', [['class', 'col-xs-8 col-sm-12']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 13, 'div', [], null, null, null, null, null)), i0.ɵdid(278528, null, 0, i4.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers, i0.ElementRef,
            i0.Renderer], { ngClass: [0, 'ngClass'] }, null), i0.ɵpod({ 'col-sm-4': 0,
            'col-sm-5': 1 }), (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                            '])), (_l()(),
            i0.ɵeld(0, null, null, 2, 'label', [['class', 'visible-xs-inline-block col-xs-4']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                                            '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'div', [['class', 'col-xs-8 col-sm-12']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_21)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'div', [['class', 'col-sm-1 icon-add btn-icon']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa-pt pt-add']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵted(null, ['\n                                            ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'row list-group-item algolia-result pointer';
        var currVal_1 = _ck(_v, 3, 0, _v.context.$implicit.selected);
        _ck(_v, 2, 0, currVal_0, currVal_1);
        var currVal_3 = _co.isItemBrandActive;
        _ck(_v, 14, 0, currVal_3);
        var currVal_4 = _ck(_v, 18, 0, _co.isItemBrandActive, !_co.isItemBrandActive);
        _ck(_v, 17, 0, currVal_4);
        var currVal_10 = _ck(_v, 51, 0, _co.isItemBrandActive, !_co.isItemBrandActive);
        _ck(_v, 50, 0, currVal_10);
        var currVal_13 = _co.isItemBrandActive;
        _ck(_v, 65, 0, currVal_13);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = i0.ɵunv(_v, 10, 0, i0.ɵnov(_v, 11).transform('ORDER.FORM.PARTS.LABEL.PART_NUMBER'));
        _ck(_v, 10, 0, currVal_2);
        var currVal_5 = _v.context.$implicit.PartNum;
        _ck(_v, 19, 0, currVal_5);
        var currVal_6 = i0.ɵunv(_v, 28, 0, i0.ɵnov(_v, 29).transform('ORDER.FORM.PARTS.LABEL.DRAWING_NUMBER'));
        _ck(_v, 28, 0, currVal_6);
        var currVal_7 = _co.getDrawingNumber(_v.context.$implicit);
        _ck(_v, 32, 0, currVal_7);
        var currVal_8 = i0.ɵunv(_v, 41, 0, i0.ɵnov(_v, 42).transform('ORDER.FORM.PARTS.LABEL.UOM'));
        _ck(_v, 41, 0, currVal_8);
        var currVal_9 = _v.context.$implicit.UOM;
        _ck(_v, 45, 0, currVal_9);
        var currVal_11 = i0.ɵunv(_v, 56, 0, i0.ɵnov(_v, 57).transform('ORDER.FORM.PARTS.LABEL.DESCRIPTION'));
        _ck(_v, 56, 0, currVal_11);
        var currVal_12 = _v.context.$implicit.Desc1;
        _ck(_v, 60, 0, currVal_12);
    });
}
function View_OrderPartComponent_23(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 61, 'div', [['class',
                'row list-group-item algolia-addItem']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'label', [['class', 'col-sm-12']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'col-sm-3']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                            '])), (_l()(),
            i0.ɵeld(0, null, null, 2, 'label', [['class', 'visible-xs-inline-block col-xs-4']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                                            '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'div', [['class', 'col-xs-8 col-sm-12']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'col-sm-2']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                            '])), (_l()(),
            i0.ɵeld(0, null, null, 2, 'label', [['class', 'visible-xs-inline-block col-xs-4']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                                            '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'div', [['class', 'col-xs-8 col-sm-12']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['N/A'])), (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'col-sm-1']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                            '])), (_l()(),
            i0.ɵeld(0, null, null, 2, 'label', [['class', 'visible-xs-inline-block col-xs-4']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                                            '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'div', [['class', 'col-xs-8 col-sm-12']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['N/A'])), (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'col-sm-5']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                            '])), (_l()(),
            i0.ɵeld(0, null, null, 2, 'label', [['class', 'visible-xs-inline-block col-xs-4']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                                            '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'div', [['class', 'col-xs-8 col-sm-12']], null, null, null, null, null)),
        (_l()(), i0.ɵeld(0, [['desc', 1]], null, 0, 'input', [['placeholder', 'description'],
            ['type', 'text']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵted(null, ['\n                                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'div', [['class', 'col-sm-1 icon-add btn-icon']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.createPart(_v.parent.context.searchString, i0.ɵnov(_v, 54).value) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['\n                                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa-pt pt-add']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                                ']))], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 3, 0, i0.ɵnov(_v, 4).transform('ORDER.FORM.PARTS.LABEL.ADD_ITEM'));
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = i0.ɵunv(_v, 11, 0, i0.ɵnov(_v, 12).transform('ORDER.FORM.PARTS.LABEL.PART_NUMBER'));
        _ck(_v, 11, 0, currVal_1);
        var currVal_2 = _v.parent.context.searchString;
        _ck(_v, 15, 0, currVal_2);
        var currVal_3 = i0.ɵunv(_v, 24, 0, i0.ɵnov(_v, 25).transform('ORDER.FORM.PARTS.LABEL.DRAWING_NUMBER'));
        _ck(_v, 24, 0, currVal_3);
        var currVal_4 = i0.ɵunv(_v, 37, 0, i0.ɵnov(_v, 38).transform('ORDER.FORM.PARTS.LABEL.UOM'));
        _ck(_v, 37, 0, currVal_4);
        var currVal_5 = i0.ɵunv(_v, 50, 0, i0.ɵnov(_v, 51).transform('ORDER.FORM.PARTS.LABEL.DESCRIPTION'));
        _ck(_v, 50, 0, currVal_5);
    });
}
function View_OrderPartComponent_22(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵted(null, ['\n                                                '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_23)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                            ']))], function (_ck, _v) {
        var currVal_0 = (_v.context.nbrResults < 1);
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_OrderPartComponent_5(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 61, 'div', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 20, 'div', [['class', 'row no-margin']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'col col-bubble']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵeld(0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'col-inputs']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵeld(0, null, null, 5, 'div', [['class', 'col-xs-12'], ['style',
                    'margin-bottom:4px;']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                       '])), (_l()(), i0.ɵted(null, ['\n                                        '])), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_6)), i0.ɵdid(802816, null, 0, i4.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵted(null, ['\n\n                            '])), (_l()(), i0.ɵeld(0, null, null, 34, 'div', [['class', 'row no-margin']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 5, 'div', [['class', 'col col-bubble']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_12)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 24, 'div', [['class', 'col-inputs']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵeld(0, null, null, 21, 'div', [['class', 'col col-xs-12 form-group']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_13)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_14)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 12, 'pt-algolia-search', [], null, [[null, 'onKeyEnter']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onKeyEnter' === en)) {
                var pd_0 = (_co.addPart($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, i6.View_AlgoliaSearchComponent_0, i6.RenderType_AlgoliaSearchComponent)),
        i0.ɵdid(245760, [[1, 4], ['search', 4]], 3, i7.AlgoliaSearchComponent, [i8.AlgoliaService,
            i9.MixpanelService], { index: [0, 'index'], params: [1, 'params'] }, { onKeyEnter: 'onKeyEnter' }),
        i0.ɵqud(335544320, 2, { itemTemplate: 0 }), i0.ɵqud(335544320, 3, { algoliaFooter: 0 }),
        i0.ɵqud(335544320, 4, { algoliaHeader: 0 }), i0.ɵpod({ hitsPerPage: 0 }), (_l()(), i0.ɵted(1, ['\n                                            '])), (_l()(), i0.ɵand(0, [[4,
                2], ['algoliaHeader', 2]], 1, 0, null, View_OrderPartComponent_15)), (_l()(),
            i0.ɵted(1, ['\n                                            '])), (_l()(), i0.ɵand(0, [[2, 2], ['algoliaResults', 2]], 1, 0, null, View_OrderPartComponent_18)),
        (_l()(), i0.ɵted(1, ['\n                                            '])), (_l()(),
            i0.ɵand(0, [[3, 2], ['algoliaFooter', 2]], 1, 0, null, View_OrderPartComponent_22)),
        (_l()(), i0.ɵted(1, ['\n                                        '])), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵted(null, ['\n                        ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.order.Items;
        _ck(_v, 21, 0, currVal_0);
        var currVal_1 = _co.order.Items.length;
        _ck(_v, 31, 0, currVal_1);
        var currVal_2 = (_co.orderType.lowercaseType == 'order');
        _ck(_v, 39, 0, currVal_2);
        var currVal_3 = (_co.orderType.lowercaseType == 'quote');
        _ck(_v, 42, 0, currVal_3);
        var currVal_4 = _co.algoliaIndex;
        var currVal_5 = _ck(_v, 49, 0, 4);
        _ck(_v, 45, 0, currVal_4, currVal_5);
    }, null);
}
function View_OrderPartComponent_26(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'div', [['class',
                'bubble-step']], null, null, null, null, null)),
        (_l()(), i0.ɵeld(0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['2']))], null, null);
}
function View_OrderPartComponent_25(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 70, 'div', [['class',
                'row no-margin']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 4, 'div', [['class', 'col col-bubble']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_26)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 19, 'div', [['class', 'col col-sm-3 form-group']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵeld(0, null, null, 2, 'label', [['class', 'control-label']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ' *'])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 8, 'input', [['class', 'form-control'],
            ['required', ''], ['type', 'text']], [[8, 'placeholder', 0], [1, 'required', 0], [2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'blur'], [null, 'input'], [null,
                'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 15)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 15).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 15)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 15)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_v.context.$implicit.PartNumber = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (('blur' === en)) {
                var pd_5 = (_co.checkField($event) !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i3.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i3.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵdid(16384, null, 0, i3.RequiredValidator, [], { required: [0, 'required'] }, null), i0.ɵprd(1024, null, i3.NG_VALIDATORS, function (p0_0) {
            return [p0_0];
        }, [i3.RequiredValidator]), i0.ɵprd(1024, null, i3.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i3.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i3.NgModel, [[8,
                null], [2, i3.NG_VALIDATORS], [8, null], [2, i3.NG_VALUE_ACCESSOR]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i3.NgControl, null, [i3.NgModel]), i0.ɵdid(16384, null, 0, i3.NgControlStatus, [i3.NgControl], null, null), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵeld(0, null, null, 2, 'span', [['class', 'help-block']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵeld(0, null, null, 13, 'div', [['class', 'col col-sm-5']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵeld(0, null, null, 2, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵeld(0, null, null, 6, 'input', [['class', 'form-control'], ['type', 'text']], [[8, 'placeholder',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 36)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 36).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 36)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 36)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_v.context.$implicit.Description = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i3.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i3.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i3.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i3.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i3.NgModel, [[8, null],
            [8, null], [8, null], [2, i3.NG_VALUE_ACCESSOR]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i3.NgControl, null, [i3.NgModel]), i0.ɵdid(16384, null, 0, i3.NgControlStatus, [i3.NgControl], null, null), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 19, 'div', [['class', 'col col-sm-2 form-group']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵeld(0, null, null, 2, 'label', [['class', 'control-label']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ' *'])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 8, 'input', [['class', 'form-control'],
            ['min', '1'], ['required', ''], ['type', 'number'], ['value', '1']], [[1, 'required',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'blur'], [null, 'input'], [null,
                'compositionstart'], [null, 'compositionend'], [null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 51)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 51).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 51)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 51)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (i0.ɵnov(_v, 52).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('input' === en)) {
                var pd_5 = (i0.ɵnov(_v, 52).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
                var pd_6 = (i0.ɵnov(_v, 52).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_7 = ((_v.context.$implicit.Qty = $event) !== false);
                ad = (pd_7 && ad);
            }
            if (('blur' === en)) {
                var pd_8 = (_co.checkField($event) !== false);
                ad = (pd_8 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i3.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i3.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵdid(16384, null, 0, i3.ɵbc, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵdid(16384, null, 0, i3.RequiredValidator, [], { required: [0, 'required'] }, null), i0.ɵprd(1024, null, i3.NG_VALIDATORS, function (p0_0) {
            return [p0_0];
        }, [i3.RequiredValidator]), i0.ɵprd(1024, null, i3.NG_VALUE_ACCESSOR, function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [i3.DefaultValueAccessor, i3.ɵbc]), i0.ɵdid(671744, null, 0, i3.NgModel, [[8, null], [2, i3.NG_VALIDATORS], [8, null], [2, i3.NG_VALUE_ACCESSOR]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i3.NgControl, null, [i3.NgModel]), i0.ɵdid(16384, null, 0, i3.NgControlStatus, [i3.NgControl], null, null), (_l()(),
            i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵeld(0, null, null, 2, 'span', [['class', 'help-block']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 4, 'div', [['class', 'col col-sm-1 icon-remove btn-icon sm-pad-fix']], null, [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.removeItem(_v.context.$implicit) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), (_l()(), i0.ɵted(null, ['\n                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa-pt pt-remove']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, [' ', '\n                                '])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                            ']))], function (_ck, _v) {
        var currVal_0 = (_v.context.index == 0);
        _ck(_v, 5, 0, currVal_0);
        var currVal_11 = '';
        _ck(_v, 16, 0, currVal_11);
        var currVal_12 = i0.ɵinlineInterpolate(1, 'partNumber', _v.context.index, '');
        var currVal_13 = _v.context.$implicit.PartNumber;
        _ck(_v, 19, 0, currVal_12, currVal_13);
        var currVal_24 = i0.ɵinlineInterpolate(1, 'description', _v.context.index, '');
        var currVal_25 = _v.context.$implicit.Description;
        _ck(_v, 38, 0, currVal_24, currVal_25);
        var currVal_35 = '';
        _ck(_v, 53, 0, currVal_35);
        var currVal_36 = i0.ɵinlineInterpolate(1, 'qty', _v.context.index, '');
        var currVal_37 = _v.context.$implicit.Qty;
        _ck(_v, 56, 0, currVal_36, currVal_37);
    }, function (_ck, _v) {
        var currVal_1 = i0.ɵunv(_v, 11, 0, i0.ɵnov(_v, 12).transform('ORDER.FORM.PARTS.LABEL.PART_NUMBER'));
        _ck(_v, 11, 0, currVal_1);
        var currVal_2 = i0.ɵinlineInterpolate(1, '', i0.ɵunv(_v, 14, 0, i0.ɵnov(_v, 22).transform('ORDER.FORM.PARTS.PLACEHOLDER.PART_NUMBER')), '');
        var currVal_3 = (i0.ɵnov(_v, 16).required ? '' : null);
        var currVal_4 = i0.ɵnov(_v, 21).ngClassUntouched;
        var currVal_5 = i0.ɵnov(_v, 21).ngClassTouched;
        var currVal_6 = i0.ɵnov(_v, 21).ngClassPristine;
        var currVal_7 = i0.ɵnov(_v, 21).ngClassDirty;
        var currVal_8 = i0.ɵnov(_v, 21).ngClassValid;
        var currVal_9 = i0.ɵnov(_v, 21).ngClassInvalid;
        var currVal_10 = i0.ɵnov(_v, 21).ngClassPending;
        _ck(_v, 14, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_14 = i0.ɵunv(_v, 25, 0, i0.ɵnov(_v, 26).transform('ORDER.FORM.FIELD_REQUIRED'));
        _ck(_v, 25, 0, currVal_14);
        var currVal_15 = i0.ɵunv(_v, 32, 0, i0.ɵnov(_v, 33).transform('ORDER.FORM.PARTS.LABEL.DESCRIPTION'));
        _ck(_v, 32, 0, currVal_15);
        var currVal_16 = i0.ɵinlineInterpolate(1, '', i0.ɵunv(_v, 35, 0, i0.ɵnov(_v, 41).transform('ORDER.FORM.PARTS.PLACEHOLDER.DESCRIPTION')), '');
        var currVal_17 = i0.ɵnov(_v, 40).ngClassUntouched;
        var currVal_18 = i0.ɵnov(_v, 40).ngClassTouched;
        var currVal_19 = i0.ɵnov(_v, 40).ngClassPristine;
        var currVal_20 = i0.ɵnov(_v, 40).ngClassDirty;
        var currVal_21 = i0.ɵnov(_v, 40).ngClassValid;
        var currVal_22 = i0.ɵnov(_v, 40).ngClassInvalid;
        var currVal_23 = i0.ɵnov(_v, 40).ngClassPending;
        _ck(_v, 35, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23);
        var currVal_26 = i0.ɵunv(_v, 47, 0, i0.ɵnov(_v, 48).transform('ORDER.FORM.PARTS.LABEL.QUANTITY'));
        _ck(_v, 47, 0, currVal_26);
        var currVal_27 = (i0.ɵnov(_v, 53).required ? '' : null);
        var currVal_28 = i0.ɵnov(_v, 58).ngClassUntouched;
        var currVal_29 = i0.ɵnov(_v, 58).ngClassTouched;
        var currVal_30 = i0.ɵnov(_v, 58).ngClassPristine;
        var currVal_31 = i0.ɵnov(_v, 58).ngClassDirty;
        var currVal_32 = i0.ɵnov(_v, 58).ngClassValid;
        var currVal_33 = i0.ɵnov(_v, 58).ngClassInvalid;
        var currVal_34 = i0.ɵnov(_v, 58).ngClassPending;
        _ck(_v, 50, 0, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34);
        var currVal_38 = i0.ɵunv(_v, 61, 0, i0.ɵnov(_v, 62).transform('ORDER.FORM.FIELD_REQUIRED'));
        _ck(_v, 61, 0, currVal_38);
        var currVal_39 = i0.ɵunv(_v, 68, 0, i0.ɵnov(_v, 69).transform('ORDER.FORM.REMOVE'));
        _ck(_v, 68, 0, currVal_39);
    });
}
function View_OrderPartComponent_24(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 4, 'div', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_25)), i0.ɵdid(802816, null, 0, i4.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                        ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.order.Items;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_OrderPartComponent_27(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 25, 'div', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                          '])), (_l()(), i0.ɵeld(0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                           '])),
        (_l()(), i0.ɵeld(0, null, null, 20, 'div', [['class', 'row no-margin form-group']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                              '])), (_l()(),
            i0.ɵeld(0, null, null, 0, 'div', [['class', 'col col-bubble']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                              '])), (_l()(),
            i0.ɵeld(0, null, null, 15, 'div', [['class', 'col-inputs']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                  '])), (_l()(),
            i0.ɵeld(0, null, null, 12, 'div', [['class', 'col col-xs-12 form-group']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                      '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'label', [['class', 'control-label']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                      '])),
        (_l()(), i0.ɵeld(0, null, null, 5, 'textarea', [['class', 'form-control'],
            ['name', 'question_comments'], ['rows', '4']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 17)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 17).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 17)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 17)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.order.QuestionComment = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i3.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i3.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i3.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i3.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i3.NgModel, [[8, null],
            [8, null], [8, null], [2, i3.NG_VALUE_ACCESSOR]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i3.NgControl, null, [i3.NgModel]), i0.ɵdid(16384, null, 0, i3.NgControlStatus, [i3.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                                  '])), (_l()(), i0.ɵted(null, ['\n                              '])), (_l()(), i0.ɵted(null, ['\n                          '])),
        (_l()(), i0.ɵted(null, ['\n                        ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_8 = 'question_comments';
        var currVal_9 = _co.order.QuestionComment;
        _ck(_v, 19, 0, currVal_8, currVal_9);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 13, 0, i0.ɵnov(_v, 14).transform('ORDER.FORM.BILLING.LABEL.COMMENTS'));
        _ck(_v, 13, 0, currVal_0);
        var currVal_1 = i0.ɵnov(_v, 21).ngClassUntouched;
        var currVal_2 = i0.ɵnov(_v, 21).ngClassTouched;
        var currVal_3 = i0.ɵnov(_v, 21).ngClassPristine;
        var currVal_4 = i0.ɵnov(_v, 21).ngClassDirty;
        var currVal_5 = i0.ɵnov(_v, 21).ngClassValid;
        var currVal_6 = i0.ɵnov(_v, 21).ngClassInvalid;
        var currVal_7 = i0.ɵnov(_v, 21).ngClassPending;
        _ck(_v, 16, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
    });
}
function View_OrderPartComponent_28(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 4, 'li', [], null, null, null, null, null)), (_l()(),
            i0.ɵeld(0, null, null, 3, 'a', [['class', 'btn-add btn-icon'], ['href',
                    'javascript:void(0);']], null, [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.addItem() !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa-pt pt-add']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 3, 0, i0.ɵnov(_v, 4).transform('ORDER.FORM.PARTS.ADD_ANOTHER_PART'));
        _ck(_v, 3, 0, currVal_0);
    });
}
export function View_OrderPartComponent_0(_l) {
    return i0.ɵvid(0, [i0.ɵqud(671088640, 1, { search: 0 }), (_l()(), i0.ɵted(null, ['    '])), (_l()(), i0.ɵeld(0, null, null, 7, 'div', [['class', 'text-c']], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_1)), i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_2)), i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n\n    '])), (_l()(), i0.ɵeld(0, null, null, 76, 'div', [['class',
                'content-inner-wizard']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n\n        '])), (_l()(),
            i0.ɵeld(0, null, null, 11, 'div', [['class', 'message-wizard']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 2, 'p', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_3)), i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_4)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(),
            i0.ɵted(null, ['\n\n        '])), (_l()(), i0.ɵeld(0, null, null, 60, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵeld(0, null, null, 57, 'div', [['class', 'col-lg-12']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 50, 'div', [['class', 'wizard content-form']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n\n                	'])), (_l()(), i0.ɵted(null, ['\n                	'])),
        (_l()(), i0.ɵeld(0, null, null, 5, 'ul', [['class', 'check-steps']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                		'])), (_l()(), i0.ɵeld(0, null, null, 2, 'li', [], null, null, null, null, null)), (_l()(), i0.ɵeld(0, null, null, 1, 'i', [], null, null, null, null, null)), i0.ɵdid(278528, null, 0, i4.NgClass, [i0.IterableDiffers,
            i0.KeyValueDiffers, i0.ElementRef, i0.Renderer], { ngClass: [0, 'ngClass'] }, null),
        (_l()(), i0.ɵted(null, ['\n                	'])), (_l()(), i0.ɵted(null, ['\n\n                    '])), (_l()(), i0.ɵeld(0, null, null, 39, 'div', [['class', 'content']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['                      \n                        '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_5)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n\n                        '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_24)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n\n                        '])),
        (_l()(), i0.ɵted(null, ['\n\n                        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_27)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n\n                        '])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 25, 'div', [['class', 'row no-margin']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 22, 'div', [['class', 'col col-xs-12']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 19, 'div', [['class', 'order_buttons_holder']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵeld(0, null, null, 16, 'ul', [['class', 'order_buttons']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderPartComponent_28)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), i0.ɵeld(0, null, null, 2, 'button', [['class', 'btn btn-default btn-cancel extra-pad btn-lg'],
            ['type', 'button']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.resetForm() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['', ''])),
        i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 4, 'li', [], null, null, null, null, null)), (_l()(), i0.ɵeld(0, null, null, 3, 'button', [['class', 'btn extra-pad btn-lg btn-primary'],
            ['routerLink', '../address'], ['type', 'button']], [[8, 'disabled', 0]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 72).onClick() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i11.RouterLink, [i11.Router, i11.ActivatedRoute, [8, null], i0.Renderer2, i0.ElementRef], { routerLink: [0, 'routerLink'] }, null), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'div', [['class', 'from-required-field']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                  * ', '\n                '])),
        i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.orderType.lowercaseType == 'order');
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = (_co.orderType.lowercaseType == 'quote');
        _ck(_v, 8, 0, currVal_1);
        var currVal_3 = (_co.orderType.lowercaseType == 'order');
        _ck(_v, 20, 0, currVal_3);
        var currVal_4 = (_co.orderType.lowercaseType == 'quote');
        _ck(_v, 23, 0, currVal_4);
        var currVal_5 = _co.getItemsFieldsClass();
        _ck(_v, 37, 0, currVal_5);
        var currVal_6 = _co.isAlgoliaSearchActive;
        _ck(_v, 43, 0, currVal_6);
        var currVal_7 = !_co.isAlgoliaSearchActive;
        _ck(_v, 46, 0, currVal_7);
        var currVal_8 = (_co.orderType.lowercaseType == 'quote');
        _ck(_v, 50, 0, currVal_8);
        var currVal_9 = !_co.isAlgoliaSearchActive;
        _ck(_v, 62, 0, currVal_9);
        var currVal_12 = '../address';
        _ck(_v, 72, 0, currVal_12);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = i0.ɵunv(_v, 16, 0, i0.ɵnov(_v, 17).transform('ORDER.FORM.PARTS.MESSAGE_1'));
        _ck(_v, 16, 0, currVal_2);
        var currVal_10 = i0.ɵunv(_v, 66, 0, i0.ɵnov(_v, 67).transform('ORDER.FORM.RESET'));
        _ck(_v, 66, 0, currVal_10);
        var currVal_11 = !_co.isValid();
        _ck(_v, 71, 0, currVal_11);
        var currVal_13 = i0.ɵunv(_v, 73, 0, i0.ɵnov(_v, 74).transform('ORDER.FORM.CONTINUE'));
        _ck(_v, 73, 0, currVal_13);
        var currVal_14 = i0.ɵunv(_v, 83, 0, i0.ɵnov(_v, 84).transform('ORDER.FORM.REQUIRED_FIELD'));
        _ck(_v, 83, 0, currVal_14);
    });
}
export function View_OrderPartComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'cx-orderpart', [], null, null, null, View_OrderPartComponent_0, RenderType_OrderPartComponent)), i0.ɵdid(114688, null, 0, i10.OrderPartComponent, [i12.Title, i11.ActivatedRoute, i2.TranslateService, i13.FlagService, i14.OrderService,
            i15.CurrentOrderService, i16.OrderValidation, i9.MixpanelService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var OrderPartComponentNgFactory = i0.ɵccf('cx-orderpart', i10.OrderPartComponent, View_OrderPartComponent_Host_0, {}, {}, []);
//# sourceMappingURL=orderpart.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./aot/src/app/order/wizard/orderpart.component.ngfactory.js
// module id = 1190
// module chunks = 0